import ApiService from "../../ApiService";

const RoomSettingService = {
    loadScreenView: (successCallback, failureCallback) => {
        ApiService.post("/mobile/app/loadscreenview", { }, successCallback, failureCallback);
    },
    getRoomInfo: (params, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/GetRoomInfoForWeb", params, successCallback, failureCallback);
    },
    updateSetting: (params, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/roomsetting/updatesetting", params, successCallback, failureCallback);
    },
    uploadPhoto: (file, successCallback, failureCallback) => {
        let formData = new FormData();
        formData.append("fileData", file);
        formData.append("table", "ChineseParkRoom");
        formData.append("field", "Photo");
        ApiService.postFileToServer("/common/file/upload", formData, successCallback, failureCallback);
    },
    sendEmail: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/vipnotification/sendemail", vo, successCallback, failureCallback);
    },
    saveClass: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/class/edit/save", vo, successCallback, failureCallback);
    },
};

export default RoomSettingService;
